export const categories = [
  {
    slug: "movie",
    name: "电影",
    icon: "ri-film-line",
    desc: "汇集院线大片与经典佳片，剧情、动作、科幻一网打尽。",
    color: "primary",
  },
  {
    slug: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    desc: "热播剧集持续更新，都市、古装、悬疑随你追。",
    color: "accent",
  },
  {
    slug: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    desc: "爆笑综艺与真人秀，下饭必备的快乐源泉。",
    color: "secondary",
  },
  {
    slug: "animation",
    name: "动画",
    icon: "ri-magic-line",
    desc: "国产动画与合家欢佳作，色彩绚丽的想象力世界。",
    color: "primary",
  },
  {
    slug: "anime",
    name: "动漫",
    icon: "ri-robot-line",
    desc: "热血番剧与治愈日常，追番党的专属角落。",
    color: "accent",
  },
  {
    slug: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    desc: "自然、人文与历史纪实，看见更广阔的世界。",
    color: "secondary",
  },
  {
    slug: "sports",
    name: "体育",
    icon: "ri-basketball-line",
    desc: "赛事集锦与运动教学，点燃你的竞技热血。",
    color: "primary",
  },
  {
    slug: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    desc: "现场演出、MV 与音乐故事，让耳朵过足瘾。",
    color: "accent",
  },
  {
    slug: "game",
    name: "游戏",
    icon: "ri-gamepad-line",
    desc: "游戏实况与攻略解说，带你玩转热门大作。",
    color: "secondary",
  },
  {
    slug: "tech",
    name: "科技",
    icon: "ri-cpu-line",
    desc: "数码评测与前沿科技，看懂未来生活。",
    color: "primary",
  },
];